export default "__VITE_ASSET__CFSZ04_H__"